
import PropTypes from 'prop-types';


const GeneList = ({ data }) => (
  <div className="drugPage_geneTableData">
    {data?.length > 0
      ? data.map((item, idx) => (
          <div key={idx} className="drugPage_geneTableList">
            {item}
          </div>
        ))
      : "N/A"}
  </div>
);

GeneList.propTypes = {
  data: PropTypes.array
};

export default GeneList;

